import { useEffect, useState,useRef } from "react";
// route
import { useNavigate } from "react-router";
// modeels
import {
  ConvocatoriaJuradosModel,
  initialValuesConvocatoriaJurados,
} from "../../../../../models/JuradosModel/convocatoriajurados.model";
// api services
import apiConvocatorias from "../../../../../api/Convocatorias/api-convocatorias";
// redux
import { useDispatch, useSelector } from "react-redux";
import { useMaestras } from "../../../../../hooks/useMaestras";
import { useEncrypt } from "../../../../../hooks/useEncrypt";
import getStorageUser from "../../../../../middlewares/GetStorageUser"
import DocumentosService from "../../../../../api/Documentos/api-documentos";
import { openNotification } from "../../../../../utils/saveFile";

export const useCrearinivitacion = () => {
  const { decrypt, encrypt } = useEncrypt();
  const idConvocatoria = decrypt(localStorage.getItem("id_convocatoria"));
  const editar_convocatoria = decrypt(
    localStorage.getItem("editar_convocatoria")
  );
  let editarConvocatoria = false;
  if (editar_convocatoria !== null) {
    editarConvocatoria = Boolean(editar_convocatoria);
  }
  const [user, setUser] = useState<any>({});
  const [loading, setLoading] = useState(false);
  const getUser = async () => {
    try {
      const user = getStorageUser()
      setUser(user);
    } catch (error) {
      console.log(error);
    }
  };

  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [convocatoriajurado, setConvocatoriajurado] =
    useState<ConvocatoriaJuradosModel>(initialValuesConvocatoriaJurados);
  const atras = () => {
    navigate("/administrador/");
  };
  const siguiente = () => {
    navigate("/administrador/");
  };

  const { areas, obtenerAreas } = useMaestras();

  useEffect(() => {
    let mounted = true;
    if (mounted) {
      getUser();
      obtenerAreas();
    }
    return () => {
      mounted = false;
    };
  }, []);

  const guardarycontinuar = async (
    AreaOptions: any,
    cambiarPestaña: any,
    state: any
  ) => {
    let infoupdate: any = { ...convocatoriajurado };
    let categoriasnuevas = infoupdate.area.map((data: any, index: number) => {
      let existe = areas.filter((x: any, i: number) => x.nombre === data);
      if (existe.length > 0) {
        return {
          value: existe[0].nombre,
          text: existe[0].nombre,
        };
      }
      return data;
    });
    infoupdate.area = categoriasnuevas;
    infoupdate.tipo_participante = [{ value: 1, text: "Persona natural" }];
    infoupdate.tipo = 2;
    infoupdate.usuario_creacion = `${user.nombres} ${user.apellidos}`;
    if (editarConvocatoria) {
      try {
        setLoading(true);
        let {data} = await apiConvocatorias.editarConvocatoriasJurados(
          infoupdate,
          idConvocatoria
        );
        await localStorage.setItem('id_convocatoria', encrypt(data.data.idconvocatorias.toString()));
        await localStorage.setItem("cambiarPestaña", encrypt("2"));
        setLoading(false);
        return cambiarPestaña({ ...state, activeTab: "2" });
      } catch (error) {
        setLoading(false);
        return console.error(error);
      }
    }
    try {
      setLoading(true);
      let data = await apiConvocatorias.guardarConvocatoriasJurados(infoupdate);
      await localStorage.setItem('id_convocatoria', encrypt(data.data.idconvocatorias.toString()));
      await localStorage.setItem("editar_convocatoria", encrypt("true"));
      await localStorage.setItem("cambiarPestaña", encrypt("2"));
      setLoading(false);
      return cambiarPestaña({ ...state, activeTab: "2" });
    } catch (error) {
      setLoading(false);
      return console.error(error);
    }
  };

  const cargarConvocatoria = async () => {
    if (editarConvocatoria) {
      let { data } = await apiConvocatorias.getConvocatoriaById(idConvocatoria);
      let dataareas = data.area.map((x: any) => x.value);
      setConvocatoriajurado({
        nombre_convocatoria: data.nombre_convocatoria,
        area: dataareas,
        cobertura: data.cobertura,
        funciones_principales: data.funciones_principales,
        tipo_participante: data.tipo_participante,
        tipo: 2,
        entidad: data.entidad,
        portada_url:data.portada_url,
        descripcion_corta:data.descripcion_corta,
        objetivo:data.objetivo,
        noparticipa:data.noparticipa,
        perfil_participante:data.perfil_participante
      });
      return setPortada(data.portada_url);

    }
  };
  const handleChange = async (value: any, name: string) => {
      let infoupdate = { ...convocatoriajurado };
      infoupdate[name] = value;
      return setConvocatoriajurado(infoupdate);
  }
  const [portada, setPortada] =  useState<any>("");
  const fileInputRef = useRef<any>();
  const [guardoArchivo, setGuardoArchivo] = useState(false);
  const guardarArchivo = async (e: any) => {
    if (e.target.files.length > 0) {
      if (e.target.files[0].size > 5000000) {
        return openNotification({
          titulo: "Error",
          descripcion: "Solo se permiten archivos menores a 5MB",
          placement: "bottomRight",
        });
      }
      if (
        e.target.files[0].type === "image/png" ||
        e.target.files[0].type === "image/jpeg"
      ) {
        const formData = new FormData();
        formData.append("archivo", e.target.files[0]);
        const data = await DocumentosService.guardarArchivo(formData);
        return setPortada(data.data);
      }
      openNotification({
        titulo: "Error",
        descripcion: "Solo se permiten archivos Png y Jpg",
        placement: "bottomRight",
      });
      return setPortada("");
    }
  };
  

  return {
    initialValuesConvocatoriaJurados,
    convocatoriajurado,
    setConvocatoriajurado,
    atras,
    siguiente,
    guardarycontinuar,
    cargarConvocatoria,
    loading,
    guardarArchivo,
    guardoArchivo,
    setGuardoArchivo,
    handleChange,
    setPortada,
    portada,
    fileInputRef
  };
};
